<template>
  <div class="path-widget">
    <div v-for="(item, index) in menus_data" :key="index" class="path-item" :class="{
      start: index == 0,
      middle: index > 0 && menus_data.length - 1 > index,
      end: menus_data.length - 1 == index,
      active: item.active,
    }" @click="selectPath(item)">
      <span>{{ item.label }}</span>
      <div class="right-carret"></div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";

export default {
  name: "",
  components: {},
  props: {},
  data: () => {
    return {
      menus_data: [
        {
          label: "Prior LIA",
          name: "prior-lia",
          active: true,
        },
        {
          label: "During LIA",
          name: "during-lia",
          active: false,
        },
        {
          label: "Post LIA",
          name: "post-lia",
          active: false,
        },
      ],
    };
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    selectPath(item) {
      let vm = this;
      vm.menus_data.forEach((element) => {
        element.active = false;
      });
      item.active = true;
      vm.$emit("selected", item.name);
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.path-widget {
  display: flex;
  border-radius: 5px;
  width: 100%;

  .path-item {
    height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0px 15px;
    position: relative;
    cursor: pointer;

    &.start {
      background: #fff;
      color: #9f9f9f;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;

      .right-carret {
        &:after {
          width: 0;
          height: 0;
          content: "";
          border-top: 15px solid transparent;
          border-left: 15px solid #fff;
          border-bottom: 15px solid transparent;
          position: absolute;
          right: -15px;
          top: 0px;
          z-index: 99;
          transform: rotate(360deg);
        }
      }

      &.active {
        background: #1ba5a4;
        color: #fff;

        .right-carret {
          &:after {
            border-left: 25px solid #1ba5a4;
            right: -25px;
          }
        }
      }
    }

    &.middle {
      margin-left: 11px;
      padding-left: 45px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      background: #fff;
      color: #9f9f9f;

      &:after {
        width: 0;
        height: 0;
        content: "";
        border-top: 25px solid transparent;
        border-left: 25px solid #f6f6f6;
        border-bottom: 25px solid transparent;
        position: absolute;
        left: -4px;
        z-index: 9;
        transform: rotate(360deg);
        border-radius: 12px;
      }

      .right-carret {
        &:after {
          width: 0;
          height: 0;
          content: "";
          border-top: 15px solid transparent;
          border-left: 25px solid #fff;
          border-bottom: 15px solid transparent;
          position: absolute;
          right: -25px;
          top: 0px;
          z-index: 99;
          transform: rotate(360deg);
        }
      }

      &.active {
        background: #1ba5a4;
        color: #fff;

        .right-carret {
          &:after {
            border-left: 25px solid #1ba5a4;
          }
        }
      }
    }

    &.end {
      margin-left: 11px;
      padding-left: 45px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      background: #fff;
      color: #9f9f9f;

      &:after {
        width: 0;
        height: 0;
        content: "";
        border-top: 25px solid transparent;
        border-left: 25px solid #f6f6f6;
        border-bottom: 25px solid transparent;
        position: absolute;
        left: -4px;
        z-index: 9;
        transform: rotate(360deg);
        border-radius: 12px;
      }

      .right-carret {
        display: none;
      }

      &.active {
        background: #1ba5a4;
        color: #fff;
      }
    }

    span {
      overflow: hidden;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 4px);
    }
  }
}
</style>
